<template>

  <div id="bg">
  <div id="wrapper">

    <!-- Nav and Login Button -->
    <LandingHeader />

    <!-- Title & Subtitle -->
    <center>
    <div class="heading">
      <h1>Login</h1>
    </div>
    </center>

    <div id="content">
      <p>Interested in Outside Voice?</p>
      <router-link to="/signup">
        <button class="signup-btn">Sign Up</button>
      </router-link>
    </div>

  </div>

  <!-- Landing Footer -->
  <LandingFooter />

  </div>


</template>


<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';

export default {

  name: 'login',

  components: {
    LandingHeader,
    LandingFooter
  },

  created() {
    analytics.page('Login');
  }

};
</script>



<style lang="scss" scoped>


#content{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 70px;
  width: 350px;
  p{
    font-size: 15px;
    color: white;
    font-weight: 500;
    text-align: center;
  }
}

h1,
h2{
  color: white;
  text-align: center;
}

.heading{
  display: block;
  margin: 0 auto;
  margin-top: 7%;
  h1{
    font-size: 38px;
    font-weight: 600;
  }
}

.signup-btn{
  color: #003122;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  padding: 12px;
  margin-top: 25px;
  background-color: #26E2A9;
  border: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  &:hover{
    background-color: #00FFC1;
  }
}

.spinner{
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  .ant-spin-dot i{
    background-color: #00FFC1 !important;
  }
}

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}


#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  padding-top: 100px;
  margin: 0 auto;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}



@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
}
#content{
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 25px;
  padding-bottom: 50px;
}

h1{
  font-size: 30px !important;
  line-height: 45px !important;
}
h2{
  display: none;
}

.heading{
  margin-top: 40px;
  h1{
    display: inline;
  }
  .whatsapp-logo{
    display: inline-block;
    height: 36px;
    width: 36px;
    background-size: 36px;
    margin-left: 8px;
    transform: translateY(8px);
  }
}

#google-btn{
  margin-bottom: 30px;
}

#signup{
  margin-bottom: 30px;
}

.email-form{
  margin-bottom: 30px;
  width: 100%;
}

}

</style>
